import { render } from "./submitForm.vue?vue&type=template&id=6fee5352&scoped=true"
import script from "./submitForm.vue?vue&type=script&lang=js"
export * from "./submitForm.vue?vue&type=script&lang=js"

import "./submitForm.vue?vue&type=style&index=0&id=6fee5352&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fee5352"]])

export default __exports__